import { render, staticRenderFns } from "./satelite_modal.vue?vue&type=template&id=5737b05e&"
import script from "./satelite_modal.vue?vue&type=script&lang=js&"
export * from "./satelite_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports